import { IKeHoachKy } from "../../model/respone/ke-hoach/IKeHoachKy";
import { apiClient } from "../apiClient";
import { KE_HOACH_NAM_ENDPOINT } from "./keHoachNamApi";

export const KE_HOACH_KY_ENDPOINT = "ke-hoach-ky";
export const keHoachKyApi = {
  SelectByNamHoc: (nam_hoc: string) => apiClient.get(`${KE_HOACH_NAM_ENDPOINT}/${nam_hoc}/ky`),
  Insert: (payload: IKeHoachKy) => apiClient.post(`${KE_HOACH_KY_ENDPOINT}`, payload),
  Update: (payload: IKeHoachKy) => apiClient.put(`${KE_HOACH_KY_ENDPOINT}`, payload),
  UpdateLockStatus: (payload: IKeHoachKy) => apiClient.patch(`${KE_HOACH_KY_ENDPOINT}/lock-status`, payload),
  Delete: (id: number) => apiClient.delete(`${KE_HOACH_KY_ENDPOINT}/${id}`),
};
